export default {"src":"/_next/static/media/paymentMethod.06fd9df0.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};